import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';


export default function AddPatientDialog({ open, onClose, onAdd }) {
    const [formData, setFormData] = useState({
    name: '',
    age: '',
    gender: ''
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    if (!formData.name.trim()) {
      alert('Nama pasien wajib diisi');
      return;
    }

    if (!formData.gender) {
      alert('Jenis kelamin wajib dipilih');
      return;
    }

    if (!formData.age) {
      alert('Usia pasien wajib diisi');
      return;
    }

    const patientData = {
      name: formData.name.trim(),
      age: parseInt(formData.age),
      gender: formData.gender
    };

    onAdd(patientData);
    
    // Reset form
    setFormData({
      name: '',
      age: '',
      gender: ''
    });
  };

  const handleCancel = () => {
    setFormData({
      name: '',
      age: '',
      gender: ''
    });
    onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (e.target.tagName === 'BUTTON' || e.target.tagName === 'TEXTAREA') return;
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleCancel}>
      <DialogContent className="max-w-md" onKeyDown={handleKeyDown}>
        <DialogHeader>
          <DialogTitle className="text-lg font-bold text-slate-900">Tambah Pasien Baru</DialogTitle>
          <DialogDescription className="text-xs text-slate-500">
            Masukkan data identitas pasien rawat inap. Seluruh kolom wajib diisi.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3.5 py-3">
          {/* Name - Required */}
          <div className="space-y-1.5">
            <Label htmlFor="name" className="text-xs font-semibold text-slate-700">
              Nama Lengkap Pasien <span className="text-red-500">*</span>
            </Label>
            <Input
              id="name"
              autoFocus
              value={formData.name}
              onChange={(e) => handleChange('name', e.target.value)}
              placeholder="cth: Tn. Budi Santoso"
              className="h-10 text-xs bg-slate-50/80 border-slate-300 focus-visible:ring-emerald-500"
              required
            />
          </div>

          {/* Age - Required */}
          <div className="space-y-1.5">
            <Label htmlFor="age" className="text-xs font-semibold text-slate-700">
              Usia (Tahun) <span className="text-red-500">*</span>
            </Label>
            <Input
              id="age"
              type="number"
              min="0"
              max="150"
              value={formData.age}
              onChange={(e) => handleChange('age', e.target.value)}
              placeholder="cth: 45"
              className="h-10 text-xs bg-slate-50/80 border-slate-300 focus-visible:ring-emerald-500"
              required
            />
          </div>

          {/* Gender - Required */}
          <div className="space-y-1.5">
            <Label htmlFor="gender" className="text-xs font-semibold text-slate-700">
              Jenis Kelamin <span className="text-red-500">*</span>
            </Label>
            <select
              id="gender"
              value={formData.gender}
              onChange={(e) => handleChange('gender', e.target.value)}
              className="w-full border border-slate-300 bg-slate-50/80 rounded-md px-3 h-10 text-xs focus:ring-2 focus:ring-emerald-500 focus:outline-none"
              required
            >
              <option value="">-- Pilih jenis kelamin --</option>
              <option value="male">Laki-laki</option>
              <option value="female">Perempuan</option>
            </select>
          </div>
        </div>

        <DialogFooter className="gap-2 pt-2 border-t border-slate-100">
          <Button variant="outline" onClick={handleCancel} className="text-xs text-slate-600 hover:bg-slate-100 rounded-xl">
            Batal
          </Button>
          <Button 
            onClick={handleSubmit}
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-xs rounded-xl shadow-sm"
          >
            Simpan Pasien Baru
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
